import React from "react";

/**
 * Lista de empleados (con skill opcional) para los tooltips de las celdas de
 * necesidades. Compartido por las tablas de necesidades.
 */
export const getEmployeesTooltipDetails = (employees) => {
	if (!employees || employees.length === 0) return "";

	return (
		<ul className="tooltip-employees">
			{employees.map((employee, i) => {
				const withUbication = employee.employee_with_ubication;
				const skill =
					withUbication && withUbication.skill && withUbication.skill > 0
						? ` (Skill: ${withUbication.skill})`
						: "";
				return (
					<li key={i}>
						{employee.name} {employee.surname} {skill}
					</li>
				);
			})}
		</ul>
	);
};

/** Lista simple de nombres de empleados planificados (para cobertura calculada). */
export const getPeopleTooltipList = (people) => {
	if (!people || people.length === 0) return "";

	return (
		<ul className="tooltip-employees">
			{people.map((person, i) => (
				<li key={i}>{person}</li>
			))}
		</ul>
	);
};
